import { Text } from "@ui/components/content/text/Text";
import { Button } from "@ui/components/forms/button/Button";
import { Flex } from "@ui/components/layout/flex/Flex";
import { ECCOIcon } from "@ui/components/media-and-icons/ecco-icon/ECCOIcon";
import { Tooltip } from "@ui/components/overlay/tooltip/Tooltip";
import { useTooltip } from "@ui/hooks/useTooltip";
import { useRef } from "react";
import { styles } from "./Bar.styles";
import { useGetHeaders } from "@hooks/useGetHeaders";
import { TryAndBuy } from "@lib/constants/contentful/try-and-buy";
import { Progress } from "@ui/components/other/progress/Progress";
import { CommonCMS } from "@lib/constants/contentful";

type Props = {
    onClick: () => void;
    isNotAvailable: boolean;
    isLoading: boolean;
};

export const Bar = ({ onClick, isNotAvailable, isLoading }: Props) => {
    const tooltipRef = useRef();
    const { isTooltipOpen, setIsTooltipOpen } = useTooltip({ tooltipRef });

    const { tooltip, wantToReseve, label, notAvailable } = useGetHeaders({
        source: CommonCMS.page,
        microcopiesWithTitles: {
            wantToReseve: TryAndBuy.bar.wantToReserve,
            tooltip: TryAndBuy.bar.tooltip,
            label: TryAndBuy.label,
            notAvailable: TryAndBuy.notAvailable,
        },
    });

    const onClickTooltip = () => setIsTooltipOpen(!isTooltipOpen);

    return (
        <Flex {...styles.container}>
            <Flex {...styles.innerWrapper}>
                {isLoading ? (
                    <Progress {...styles.progress} variant="black" isIndeterminate />
                ) : (
                    <>
                        <Text>{isNotAvailable ? notAvailable : wantToReseve}</Text>
                        <Tooltip
                            isOpen={isTooltipOpen}
                            hasArrow={false}
                            label={tooltip}
                            closeOnScroll={true}
                            aria-label={tooltip}
                            {...styles.tooltip}
                        >
                            <ECCOIcon
                                ref={tooltipRef}
                                name="info"
                                onClick={onClickTooltip}
                                sx={styles.tooltipIcon}
                            />
                        </Tooltip>
                    </>
                )}
            </Flex>
            <Button
                isLoading={isLoading}
                isDisabled={isNotAvailable}
                onClick={onClick}
                {...styles.button}
                variant="ghost"
            >
                {label}
            </Button>
        </Flex>
    );
};
